module.exports = __webpack_public_path__ + "public/images/slider/davidkina.c73bec944c6d76124bcfe72b006b07d4.webp";